export default "__VITE_ASSET__408fc91f__"